import React, { Suspense } from 'react';
import { Loading } from '../shared/Loading';
import { LoadingFailed } from '../shared/LoadingFailed';

const LandingPageContent = React.lazy(() => import('./LandingPageContent'));

export class LandingPage extends React.Component<Record<string, unknown>, { hasError?: boolean }> {
  constructor(props: Record<string, unknown>) {
    super(props);
    this.state = { hasError: false };
  }
  public static getDerivedStateFromError(_: any) {
    return { hasError: true };
  }
  public render() {
    if (this.state.hasError) {
      return <LoadingFailed />;
    }
    return (
      <Suspense fallback={<Loading />}>
        <LandingPageContent />
      </Suspense>
    );
  }
}
